<template>
  <header class="top-bar p-3 flex align-items-center justify-content-between sticky top-0 z-10">
    <div class="flex align-items-center gap-2">
      <Button v-if="isDesktop" class="p-button-text p-button-rounded p-button-sm" @click="$emit('toggle-sidebar')">
        <i :class="collapsed ? 'pi pi-angle-right' : 'pi pi-angle-left'"></i>
      </Button>
      <Button v-else class="p-button-text p-button-rounded p-button-lg mr-3" @click="$emit('toggle-mobile')"
        icon="pi pi-bars" />
    </div>
    <div class="flex flex-wrap align-items-center justify-content-end md:gap-4 gap-1 ">
      <slot name="search"></slot>
      <GoogleTranslate class="px-2"/>
    </div>
    
  </header>
</template>

<script setup>
import Button from "primevue/button";
import { defineEmits, defineProps } from "vue";
import GoogleTranslate from '@/components/GoogleTranslate.vue';

defineEmits(["toggle-sidebar", "toggle-mobile"]);
defineProps({
  collapsed: Boolean,
  isDesktop: Boolean,
  role: String,
});
</script>

<style scoped>
.top-bar {
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--surface-border);
  height: 10vh;
  padding: 1rem;
  background-color: var(--gray-200);
}

.menu-button,
.p-button-text {
  color: var(--primary-color);
}

/* Search input styling */
.search-input {
  border: 1px solid var(--surface-border);
  border-radius: 6px;
  padding: 0.5rem 2rem;
  min-width: 180px;
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: var(--primary-color);
  outline: none;
}


button {
  transition: all 0.2s ease-in-out;
}

button:hover {
  transform: scale(1.05);
}
</style>
